/*
Import all child theme specific scripts here.
Block interactivity (sliders, accordions, cruise carousels) ships with the
"BANC Blocks" and "Pontoon BANC Addon" plugins, not the theme.
*/

import "./custom/navbar.js"; // Navbar functionality
import "./libs/splide/splide_custom_simple_initialize.js"; // Generic Splide initialiser
import "./custom/load-more-posts.js"; // Load-more posts (AJAX)
import "./custom/popup-modal.js"; // Generic popup/modal handling
import "./custom/hero_slider.js"; // hero slider
import "./custom/hero_video.js"; // hero slider
import "./custom/section-nav.js"; // Sectioned-page anchor sidebar scrollspy
import "./custom/hero_box.js"; // Image hero: box reuses the loaded srcset candidate
import "./custom/filter-forms.js"; // Careers + News & PR archive: submit-on-change filters
import "./custom/scroll-reveal.js"; // Page blocks fade in on scroll
